import { useQuery } from "@tanstack/react-query";
import { getAllRacesByTrack } from "../api";
import { filterEmpty } from "..";

const useAllRacesByTrack = (trackCode: string) => {
  const { data, isError } = useQuery({
    queryKey: ["all races by track", trackCode],
    queryFn: () => getAllRacesByTrack({ trackCode }),
  });
  const races = filterEmpty(data?.HR_Races ?? []);
  return {
    races,
    isError,
  };
};

export default useAllRacesByTrack;
